import { render, staticRenderFns } from "./DBAddUpdate.html?vue&type=template&id=6d13053d&scoped=true&"
import script from "./DBAddUpdate.vue?vue&type=script&lang=js&"
export * from "./DBAddUpdate.vue?vue&type=script&lang=js&"
import style0 from "./DBAddUpdate.vue?vue&type=style&index=0&id=6d13053d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d13053d",
  null
  
)

export default component.exports